import React, { useState, useEffect } from 'react';
import styles from './AnswerModal.module.scss';

const AnswerModal = ({ index, onClose, gameId, hasPlaces, hasHints }) => {
  const [response, setResponse] = useState('');
  const [hint, setHint] = useState('');
  const [location, setLocation] = useState('');

  useEffect(() => {
    setResponse(localStorage.getItem(`answer_${gameId}_${index}`) || '');
    setHint(localStorage.getItem(`hint_${gameId}_${index}`) || '');
    setLocation(localStorage.getItem(`location_${gameId}_${index}`) || '');
  }, [index, gameId]);

  const handleSave = () => {
    localStorage.setItem(`answer_${gameId}_${index}`, response);
    localStorage.setItem(`hint_${gameId}_${index}`, hint);
    localStorage.setItem(`location_${gameId}_${index}`, location);
    onClose();
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.title}>Énigme {index + 1}</h3>
        <hr className={styles.hr} />
        <div className={styles.formControl}>
            <label>Réponse</label>
            <input value={response} onChange={(e) => setResponse(e.target.value)} />
        </div>

        {hasHints && (
        <div className={styles.formControl}>
            <label>Indice</label>
            <input value={hint} onChange={(e) => setHint(e.target.value)} />
        </div>
        )}

        {hasPlaces && (
          <div className={styles.formControl}>
            <label>Lieu</label>
            <input value={location} onChange={(e) => setLocation(e.target.value)} />
          </div>
        )}
        
        <button onClick={handleSave}>Enregistrer</button>
      </div>
    </div>
  );
};

export default AnswerModal;
